export const ErrorMsgMap: { [key: string]: { [key: string]: string } } = {
  "en-US": {
    "ERROR.cloud.-2": "Capability token invalidation",
    "ERROR.cloud.MAX0170004":
      "Description Failed to query user information in the model service",
    "ERROR.cloud.20000": "The x-token is missing. Procedure",
    "ERROR.cloud.20001": "The capability verification parameter is missing",
    "ERROR.cloud.30000": "Capability token invalidation",
    "ERROR.cloud.N001": "service config is not injected: {serviceCode}",
    "ERROR.cloud.N002": "{serviceCode} not found",
    "ERROR.native.I001": "iot init error",
    "ERROR.native.I002": "getService init error:{msg}",
    "ERROR.native.I003": "getDevice init error:{msg}",
    "ERROR.native.I004": "load Ext service fail",
    "ERROR.native.I005": "registerServiceProperty Init Error: {msg}",
    "ERROR.native.C001": "command fail: {error}",
    "ERROR.native.C002": "command thingService error {code}: {msg}",
    "ERROR.native.C003": "command error {code}: {msg}",
    "ERROR.native.C004": "commands fail: {error}",
    "ERROR.native.C005": "commands thingService error {code}: {msg}",
    "ERROR.native.C006": "commands error {code}: {msg}",
    "ERROR.native.C007":
      "property method name must start with get or set: {methodName}",
    "ERROR.native.C008": "setProperty fail: {error}",
    "ERROR.native.C009": "getProperty fail: {error}",
    "ERROR.native.C010": "setProperty error {code}: {msg}",
    "ERROR.native.C011": "getProperty error {code}: {msg}",
    "ERROR.native.C012": "registerServiceEventByListener error: {error}",
    "ERROR.native.C013": "device.setProperty fail: {error}",
    "ERROR.native.C014": "device.setProperty error {code}: {msg}",
    "ERROR.native.C015": "device.getProperty error {code}: {msg}",
    "ERROR.native.C016": "device.getProperty fail: {error}",
    "ERROR.native.C017": "bindExt error: {msg}",
    "ERROR.native.S001":
      "{serviceType}: {serviceName} getService list is empty",
    "ERROR.native.S002": "{deviceId}: not found in service list",
    "ERROR.native.S003": "{serviceName}: no deviceId specified",
    "ERROR.native.S004": "{serviceType}: service Not Found ",
    "ERROR.native.S005": "{deviceId} not found:{msg}",
    "ERROR.native.S006": "getDevice {deviceId} not found: {msg}",
    "ERROR.native.V002": "Download Fail, code={errorCode}, msg={errorMsg}",
    "ERROR.native.V003": "IOT Ability Initialization Fail, code={errorCode}",
    "ERROR.native.V004": "IOT pre-initialization Fail, code={errorCode}",
    "ERROR.native.V005": "IOT Service Break-down, type={serviceType}",
    "ERROR.native.V006": "Download Ext Fail, code={errorCode}, msg={errorMsg}",
    "ERROR.native.T001": "{methodName}: link not init",
    "ERROR.native.T002": "can't get {methodName} serviceType",
  },
  "zh-CN": {
    "ERROR.cloud.N001": "未注入网关服务配置: {serviceCode}",
    "ERROR.cloud.N002": "未找到{serviceCode}服务",
    "ERROR.cloud.-2": "能力token失效",
    "ERROR.cloud.MAX0170004": "模型服务内部查询用户信息失效",
    "ERROR.cloud.20000": "缺少x-token",
    "ERROR.cloud.20001": "缺少能力验证参数",
    "ERROR.cloud.30000": "能力token失效",
    "ERROR.native.I001": "IoT初始化失败",
    "ERROR.native.I002": "获取服务初始化失败:{msg}",
    "ERROR.native.I003": "获取设备初始化失败:{msg}",
    "ERROR.native.I004": "绑定无线服务失败",
    "ERROR.native.I005": "registerServiceProperty 初始化失败:{msg}",
    "ERROR.native.S001": "{serviceType}:{serviceName}获取服务列表为空",
    "ERROR.native.S002": "{deviceId}: 未能在服务列表中找到",
    "ERROR.native.S003": "{serviceName}: 未指定设备ID",
    "ERROR.native.S004": "{serviceType}: 服务未找到",
    "ERROR.native.S005": "{deviceId} 未找到服务: {msg} ",
    "ERROR.native.S006": "未获取到 {deviceId} 设备: {msg}",
    "ERROR.native.C001": "调用指令失败:{error}",
    "ERROR.native.C002": "调用物服务指令异常{code}: {msg}",
    "ERROR.native.C003": "调用指令异常{code}: {msg}",
    "ERROR.native.C004": "调用批量指令失败:{error}",
    "ERROR.native.C005": "调用物服务批量指令异常{code}: {msg}",
    "ERROR.native.C006": "调用批量指令异常 {code}: {msg}",
    "ERROR.native.C007": "属性方法名称必须以get或者set开头:{methodName}",
    "ERROR.native.C008": "property设置失败: {error}",
    "ERROR.native.C009": "property获取失败: {error}",
    "ERROR.native.C010": "property设置异常 {code}: {msg}",
    "ERROR.native.C011": "property获取异常{code}: {msg}",
    "ERROR.native.C012": "注册 event 侦听类型服务异常:{error}",
    "ERROR.native.C013": "设备设置property失败:{error}",
    "ERROR.native.C014": "设置property异常{code}: {msg}",
    "ERROR.native.C015": "获取设备property失败:{error}",
    "ERROR.native.C016": "获取设备property异常{code}: {msg}",
    "ERROR.native.C017": "绑定设备失败:{msg}",
    "ERROR.native.V002": "下载失败, 错误码={errorCode}, 错误信息={errorMsg",
    "ERROR.native.V004": "初始化前置流程失败, 错误码={errorCode}",
    "ERROR.native.V003": "初始化失败, 错误码={errorCode}",
    "ERROR.native.V005": "服务已下线, 类型={serviceType}",
    "ERROR.native.V006":
      "外置下载失败,  错误码={errorCode}, 错误信息={errorMsg}",
    "ERROR.native.T001": "{methodName}:配置项未初始化",
    "ERROR.native.T002": "获取不到{methodName}的服务类型",
  },
}
